/**
 * Tipos de Etiqueta
 *
 * NaoFormatado: com "$"
 *
 * Formatado: sem o "$"
 *
 * @enum {typeof EnumTiposEtiqueta[keyof typeof EnumTiposEtiqueta]}
 */

export const EnumTiposEtiqueta = Object.freeze({
    NaoFormatado: 1,
    Formatado: 2
});
